export function get2DecimalsFormat(value: string): string {
  return parseFloat(value).toFixed(2);
}

export function get2DecimalsFormatNumber(value: number): string {
  return value.toFixed(2);
}

export function roundTwoDecimals(amount: number): number {
  return Math.round(amount * 100) / 100;
}
